import { useEffect, useRef } from "react";
import { createFocusTrap } from "focus-trap";

export const useFocusTrap = (isOpen) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (isOpen && containerRef.current) {
      const trap = createFocusTrap(containerRef.current, {
        escapeDeactivates: true,
        clickOutsideDeactivates: true,
      }) ;
      trap.activate();
      return () => trap.deactivate();
    }
  }, [isOpen]);

  return containerRef;
};
